import { render, staticRenderFns } from "./shareList.vue?vue&type=template&id=2a5b6042&scoped=true"
import script from "./shareList.vue?vue&type=script&lang=js"
export * from "./shareList.vue?vue&type=script&lang=js"
import style0 from "./shareList.vue?vue&type=style&index=0&id=2a5b6042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b6042",
  null
  
)

export default component.exports